import './KnowledgeBase.scss'

//@ts-ignore
import Layout from '@componentsfld/core/Layout'
import { HeadProps } from 'gatsby'
import React, { FunctionComponent } from 'react'
import { IPageContext } from 'Root/Shared/utils/data/buildTypedPage'
import PuxLink from 'Root/Shared/utils/PuxLink'
import { PuxVWO } from 'Root/Shared/utils/PuxVWO'
import GoogleSearch from 'Shared/components/GoogleSearch/GoogleSearch'
import {
  GenericPageProps,
  IEasySoftwareKnowledgeBase,
} from 'Shared/queries/page-queries'
import { getLocalizedUrl } from 'Shared/utils/localeURL'
import PuxMetaTagsGatsby from 'Shared/utils/PuxMetaTagsGatsby'

//@ts-ignore
import icon from '../../images/placeholder.svg'

const KnowledgeBase: FunctionComponent<
  GenericPageProps<IEasySoftwareKnowledgeBase>
> = (props) => {
  const pageData = props.pageContext.pageData
  const headerData = props.pageContext.headerData
  const footerData = props.pageContext.footerData

  return (
    <Layout
      localizedPath={pageData.localization?.localizations}
      footerData={footerData}
      headerData={headerData}
      pageContentItemId={pageData.contentItemId}
      pageProperties={props.pageContext.pageProperties}
      resStrings={props.pageContext.resStrings}
    >
      <div className='Container KnowledgeBase'>
        <div className='KnowledgeBase-header'>
          <h1>{pageData.displayText}</h1>
          <GoogleSearch searchType='knowledgebase' />
        </div>
        <div className='KnowledgeBase-container'>
          {props.pageContext?.knowledgeBaseData?.map((item, index) => (
            <PuxLink
              className='KnowledgeBase-item'
              to={getLocalizedUrl(item.path)}
              key={item.path}
            >
              <div className='KnowledgeBase-item-header'>
                <img
                  src={item.iconPath ?? icon}
                  alt=""
                  width={24}
                  height={24}
                />
                <h2>{item.displayTextWithoutNumber}</h2>
              </div>
              {item.description && <p className='KnowledgeBase-item-description'>{item.description}</p>}
            </PuxLink>
          ))}
        </div>
      </div>
    </Layout>
  )
}

export default KnowledgeBase

export function Head(
  props: HeadProps<never, IPageContext<IEasySoftwareKnowledgeBase>>
) {
  const pageData = props.pageContext.pageData
  const metaTags = props.pageContext.metaTags

  return (
    <>
      <PuxMetaTagsGatsby
        {...metaTags}
        localizedPaths={pageData.localization?.localizations}
      />
      <PuxVWO isEnabled={props.pageContext.pageProperties?.pagePropertiesVWOEnabled} />
    </>
  )
}
